import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@/i18n/navigation";
import { sessionQueryKey } from "./use-session";

/**
 * Ends the session: clears the httpOnly cookie server-side, drops every
 * cached query (nothing from the previous account may linger on screen),
 * marks the session as signed-out, then navigates to `redirectTo`.
 */
export function useLogout(redirectTo = "/") {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useCallback(async () => {
    await fetch("/api/v1/auth/logout", { method: "POST" }).catch(() => null);
    queryClient.removeQueries();
    queryClient.setQueryData(sessionQueryKey, null);
    router.push(redirectTo);
  }, [queryClient, router, redirectTo]);
}
